import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DashboardService } from '../service/dashboard.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { JsonPipe } from '@angular/common';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';

// interface Role {
//   value: string;
//   viewValue: string;
// }

interface companyData {
  agent_code: number;
  agent_name: string;
  phone: string;
  agent_pin_set: string;
  email: string;
  agent_type: string;
  agent_date_created: string;
  agent_date_modified: string;
}



@Component({
  selector: 'app-add-broker',
  templateUrl: './add-broker.component.html',
  styleUrls: ['./add-broker.component.scss']
})

export class addBrokerComponent implements OnInit {

  errors = {}

  //loadings
  isBrokerCompanyLoading: boolean = false;

  //broker company
  loadedBrokerCompany: companyData[];
  filteredBrokerCompany: companyData[];

  currentUser;

  requestPayload = {
    broker_user_main_broker_code: 0,
    broker_user_email: '',
    broker_user_phone: '',
    broker_user_first_name: '',
    broker_user_last_name: '',
    broker_user_created_by: '',
    broker_user_office: '',
    broker_company_name: ''
  }

  requestPayloadLogin = {
    email: '',
    role: 'admin'
  }

  companyData: companyData[] = [];


  selectedMake: companyData = {
    agent_code: 0,
    agent_name: "",
    phone: "",
    agent_pin_set: "",
    email: "",
    agent_type: "",
    agent_date_created: "",
    agent_date_modified: ""
  }


  addBrokerForm: FormGroup;
  broker_company_name = new FormControl();
  brokerCode: number;
  brokerCompanyName: string;


  constructor(
    public formBuilder: FormBuilder,
    public service: DashboardService,
    private router: Router
  ) { }


  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('userdata'))
    this.initializeAddBrokerForm()

    //Load companies
    this.onLoadBrokerCompany()

    //on companies Filter
    this.onFilterBrokerCompany()

  }

  initializeAddBrokerForm() {
    this.addBrokerForm = this.formBuilder.group({
      //broker_user_main_broker_code: this.requestPayload.broker_user_main_broker_code,
      broker_user_email: new FormControl('', [Validators.required]),
      broker_user_phone: new FormControl('', [Validators.required]),
      broker_user_first_name: new FormControl('', [Validators.required]),
      broker_user_last_name: new FormControl('', [Validators.required]),
      broker_user_office: new FormControl(''),
      // broker_company_name: new FormControl('', [Validators.required]),
    });

  }





  postBroker() {

    if (this.addBrokerForm.valid && this.brokerCode) {
      this.requestPayload = this.addBrokerForm.value;
      this.requestPayload.broker_user_created_by = this.currentUser.email;

      this.requestPayload.broker_user_main_broker_code = this.brokerCode
      this.requestPayload.broker_company_name = this.brokerCompanyName


     // console.log("requestPayload:  " + JSON.stringify(this.requestPayload));

      Swal.showLoading();
      this.service.addBroker(this.requestPayload)
        .subscribe(response => {
       //   console.log(response);

          Swal.close();
          if (response['responseCode'] === '000') {
            this.initializeAddBrokerForm();
            this.brokerCode = 0;
            this.brokerCompanyName = "";

            (Swal as any).fire({
              icon: 'success',
              title: 'Successful',
              text: 'Broker user account created successfully.',
            });

            this.router.navigate(['/add-broker'])

          } else {
            (Swal as any).fire({
              icon: 'warning',
              title: 'Oops...',
              text: response['responseMessage'],
              footer: ''
            });
          }

        }, error => {
          (Swal as any).fire({
            icon: 'error',
            title: 'Oops...',
            text: JSON.stringify(error.error),
            footer: ''
          });
          Swal.close();
        })


    } else {
      (Swal as any).fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Please fill all form fields',
        footer: ''
      });

    }

  }


  onSelectMake(make: companyData) {
   // console.log('make selected', make)
    this.errors = { ...this.errors, make: false };

    this.selectedMake = make;
    this.brokerCode = this.selectedMake.agent_code
    this.brokerCompanyName = this.selectedMake.agent_name

  }


  //autocomplete search make
  onLoadBrokerCompany() {
    this.filteredBrokerCompany = [];
    this.loadedBrokerCompany = [];

    this.requestPayloadLogin.email = this.currentUser.email;
    this.requestPayloadLogin.role = this.currentUser.role;
   // console.log("requestPayloadLogin>>>> " + JSON.stringify(this.requestPayloadLogin));

    this.service.getBrokerCompanies(this.requestPayloadLogin)
      .toPromise()
      .then((response: any) => {
        if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {
    //      console.log("companyData>>>> " + JSON.stringify(response.responseData))

          response.responseData.map((response: companyData) => {
            let company: companyData = { ...response, agent_name: `${response.agent_name}` };
            this.loadedBrokerCompany.push(company);
            this.filteredBrokerCompany.push(company);
          })
        }
      });

  }

  onFilterBrokerCompany() {
    this.broker_company_name.valueChanges
      .pipe(
        debounceTime(0),
        tap(() => {
          this.filteredBrokerCompany = [];
          this.isBrokerCompanyLoading = true;
        }),
        switchMap(value => {
          if (value.length) {
            return Observable.create(observer => {
              let payload = this.loadedBrokerCompany.filter((response: companyData) => response.agent_name.trim().toLowerCase().includes(value.trim().toLowerCase()) == true)
              observer.next(payload)
            })
              .pipe(
                finalize(() => {
                  this.isBrokerCompanyLoading = false
                }),
              )
          }
          else {
            this.isBrokerCompanyLoading = false
            return new Observable<[]>();
          }
        }
        )
      )
      .subscribe((models: any) => {
        if (models)
          models.map((response: companyData) => {

            this.filteredBrokerCompany.push({ ...response, agent_name: `${response.agent_name}` });
          })
      })
  }


  //company change event
  onBrokerCompanyChange(event) {
    if (!event.target.value) {

      this.selectedMake = {
        agent_code: 0,
        agent_name: "",
        phone: "",
        agent_pin_set: "",
        email: "",
        agent_type: "",
        agent_date_created: "",
        agent_date_modified: ""
      }

      this.requestPayload.broker_user_main_broker_code = this.selectedMake.agent_code

    } else {
      //this.filteredModels=[];
    }

  }


  addBroker() {
    this.router.navigate(['/add-broker'])
  }


  brokers() {
    this.router.navigate(['/brokers'])
  }

}
